import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "confirm-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = {
  key: 0,
  class: "changes-table"
}
const _hoisted_4 = { class: "field-name" }
const _hoisted_5 = { class: "new-column" }
const _hoisted_6 = {
  key: 1,
  class: "post-disb-section"
}
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = {
  key: 0,
  class: "changes-table"
}
const _hoisted_9 = { class: "field-name" }
const _hoisted_10 = { class: "new-column" }
const _hoisted_11 = {
  key: 1,
  class: "single-column-table"
}
const _hoisted_12 = { class: "field-value" }
const _hoisted_13 = { class: "field-value" }
const _hoisted_14 = { class: "field-value" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "field-value" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "field-value" }
const _hoisted_19 = { class: "field-value" }
const _hoisted_20 = {
  key: 2,
  class: "new-disb-section"
}
const _hoisted_21 = { class: "single-column-table" }
const _hoisted_22 = { class: "field-value" }
const _hoisted_23 = { class: "field-value" }
const _hoisted_24 = { class: "field-value" }
const _hoisted_25 = { class: "field-value" }
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = {
  key: 0,
  class: "checkbox-label"
}
const _hoisted_28 = { class: "modal-actions" }
const _hoisted_29 = ["disabled"]

import { ref } from 'vue';
import { DisbursementChangesSummary } from '@/types/disbursements';


export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementConfirmModal',
  props: {
    changes: {},
    isSaving: { type: Boolean },
    canGenerateModificationFile: { type: Boolean }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any) {

const props = __props;



const generateModFile = ref(props.canGenerateModificationFile !== false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('cancel')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Confirm", -1)),
        _createElementVNode("button", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
        }, "×")
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "modal-subtitle" }, "Please review your changes before submitting", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.changes, (disb) => {
        return (_openBlock(), _createElementBlock("div", {
          key: disb.disbursementId,
          class: "disbursement-changes"
        }, [
          (disb.fieldChanges && disb.fieldChanges.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Cert. Seq. " + _toDisplayString(disb.certSeq) + _toDisplayString(disb.isNew ? '' : `/Disb. Seq. ${disb.disbSeq}`), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("th", null, "PREVIOUS", -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("th", { class: "new-column new-label" }, "NEW", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disb.fieldChanges, (change) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: change.field
                    }, [
                      _createElementVNode("td", _hoisted_4, _toDisplayString(change.field), 1),
                      _createElementVNode("td", null, _toDisplayString(change.previous), 1),
                      _createElementVNode("td", _hoisted_5, _toDisplayString(change.new), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (disb.postDisbChange)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("h4", _hoisted_7, " Post Disbursement Change" + _toDisplayString(disb.postDisbChange.isEdit ? ' - Updates' : '') + " for Cert. Seq. " + _toDisplayString(disb.certSeq) + _toDisplayString(disb.isNew ? '' : `/Disb. Seq. ${disb.disbSeq}`), 1),
                (disb.postDisbChange.isEdit && disb.postDisbChange.changes)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
                      _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th"),
                          _createElementVNode("th", null, "PREVIOUS"),
                          _createElementVNode("th", { class: "new-column" }, "NEW")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disb.postDisbChange.changes, (change) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: change.field
                          }, [
                            _createElementVNode("td", _hoisted_9, _toDisplayString(change.field), 1),
                            _createElementVNode("td", null, _toDisplayString(change.previous), 1),
                            _createElementVNode("td", _hoisted_10, _toDisplayString(change.new), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("table", _hoisted_11, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("td", { class: "field-name" }, "Disb. Amount", -1)),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(disb.postDisbChange.newAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("td", { class: "field-name" }, "Processing Date", -1)),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(disb.postDisbChange.processingDate), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("td", { class: "field-name" }, "Effective Date", -1)),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(disb.postDisbChange.effectiveDate), 1)
                        ]),
                        (disb.postDisbChange.settleDate)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "field-name" }, "Settle Date", -1)),
                              _createElementVNode("td", _hoisted_16, _toDisplayString(disb.postDisbChange.settleDate), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (disb.postDisbChange.method)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "field-name" }, "Method", -1)),
                              _createElementVNode("td", _hoisted_18, _toDisplayString(disb.postDisbChange.method), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("tr", null, [
                          _cache[14] || (_cache[14] = _createElementVNode("td", { class: "field-name" }, "Post Disb. Change Reason", -1)),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(disb.postDisbChange.reason), 1)
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
          (disb?.isNew && disb.newDisbursement)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "section-title new-label" }, "NEW DISBURSEMENT", -1)),
                _createElementVNode("table", _hoisted_21, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", { class: "field-name" }, "Status", -1)),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(disb.newDisbursement.status), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", { class: "field-name" }, "Amount", -1)),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(disb.newDisbursement.amount), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("td", { class: "field-name" }, "Date", -1)),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(disb.newDisbursement.date), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("td", { class: "field-name" }, "Method", -1)),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(disb.newDisbursement.method), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_26, [
        (props.canGenerateModificationFile)
          ? (_openBlock(), _createElementBlock("label", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((generateModFile).value = $event))
              }, null, 512), [
                [_vModelCheckbox, generateModFile.value]
              ]),
              _cache[20] || (_cache[20] = _createTextVNode(" Generate Modification File ", -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "btn-cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn-confirm",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm', generateModFile.value))),
            disabled: props.isSaving
          }, _toDisplayString(props.isSaving ? 'Saving...' : 'Confirm Changes'), 9, _hoisted_29)
        ])
      ])
    ])
  ]))
}
}

})